<template>
  <div>
    <Stack
      class="stk-p-6"
      gap="4"
    >
      <Stack gap="0">
        <Title size="7">
          Teams
        </Title>
        <Subtitle size="5">
          Manage your firm's teams and advisors
        </Subtitle>
      </Stack>

      <Pills>
        <PillsList>
          <PillItem
            v-for="link in navigationLinks"
            :key="link.to.name"
            :to="link.to"
            :icon="link.icon"
            :only-exact="link.onlyExact"
            replace
          >
            {{ link.label }}
          </PillItem>
        </PillsList>
      </Pills>
    </Stack>

    <router-view />
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import {
  Pills,
  PillsList,
  PillItem,
  Stack,
  Title,
} from '@stakeui';
import { useTeamsStore } from '@frontend/ui/stores/teamsStore.js';

const teamsStore = useTeamsStore();

const navigationLinks = computed(() => [
  {
    label: 'List',
    icon: 'fas fa-users',
    onlyExact: true,
    to: { name: 'teams-index' },
  },
  {
    label: 'Firm Advisors',
    icon: 'fas fa-user-shield',
    to: { name: 'firm-advisors' },
  },
]);

onMounted(() => teamsStore.fetchSubjects());
</script>
